"use strict";

const urlHelper = (function () {
    const getAlternativeDatesUrl = (cruiseId, airportCode, packageRotationId, occupancyString, isCabinFilterSelected, isSearchModal) => {
        return `/mvc/algolia/getalternativedates?cruiseHandlerId=${packageRotationId}&departureAirport=${airportCode}&cruiseId=${cruiseId}&cabinOccupancyType=${occupancyString}&isCabinFilterSelected=${isCabinFilterSelected}&isSearchModal=${isSearchModal}`;
    };

    const getCruiseGalleryUrl = (cruiseId) => {
        return `/mvc/algolia/GetCruiseGallery?cruiseId=${cruiseId}`;
    };

    const getPackageUpsellUrl = (cruiseId, airportCode, packageRotationId, occupancyString, originalCruiseId = null) => {
        return `/mvc/itinerarypage/getpackageupsell?sailingHandlerId=${packageRotationId}&departureAirport=${airportCode}&cruiseId=${cruiseId}&cabinOccupancyType=${occupancyString}&originalCruiseId=${originalCruiseId}`;
    };

    const getCabinSummaryImagesUrl = (supplierCode, shipId, departureDate) => {
        const params = new URLSearchParams({
            supplierCode: supplierCode || '',
            shipId: String(shipId || ''),
            departureDate: departureDate || ''
        });

        return `/api/cabin-summary/images?${params.toString()}`;
    };

    const getHeaderResourcesUrl = () => {
        return '/api/Header/GetResources';
    };

    const getSigninModalResourcesUrl = () => {
        return '/api/SigninModal/GetResources';
    };

    const getAddCruiseToWishListUrl = (cruiseId) => {
        return `/MVC/SearchResult/AddCruiseToWishList?cruiseId=${encodeURIComponent(cruiseId)}`;
    };

    const getRemoveCruiseFromWishListUrl = (cruiseId) => {
        return `/MVC/SearchResult/RemoveCruiseFromWishList?cruiseId=${encodeURIComponent(cruiseId)}`;
    };

    const getLogNoResultUrl = (data) => {
        return `/MVC/SearchResult/LogNoResult?data=${encodeURIComponent(data)}`;
    };

    const getDeckPlanPartialUrl = (targetDeckId, shipId, supplierCode) => {
        return `/mvc/deckplan/deckplanpartial?targetDeckId=${targetDeckId}&shipId=${shipId}&supplierCode=${supplierCode}`;
    };

    const getItineraryTimelineUrl = (cruiseId) => {
        return `/mvc/algolia/GetItineraryTimeline?cruiseId=${cruiseId}`;
    };

    const getWhatsIncludedUrl = (cruiseId, cabinMetaType, cabinOccupancyType) => {
        return `/mvc/algolia/getwhatsincluded?cruiseId=${cruiseId}&cabinMetaType=${encodeURIComponent(cabinMetaType)}&cabinOccupancyType=${encodeURIComponent(cabinOccupancyType)}`;
    };

    const getAlgoliaModuleDataUrl = () => {
        return '/mvc/searchresult/getalgoliamoduledata' + window.location.search;
    };

    const getPluginViewModelUrl = () => {
        return '/api/algolia/getpluginviewmodel';
    };

    return {
        getAlternativeDatesUrl,
        getCruiseGalleryUrl,
        getPackageUpsellUrl,
        getCabinSummaryImagesUrl,
        getHeaderResourcesUrl,
        getSigninModalResourcesUrl,
        getAddCruiseToWishListUrl,
        getRemoveCruiseFromWishListUrl,
        getLogNoResultUrl,
        getDeckPlanPartialUrl,
        getItineraryTimelineUrl,
        getWhatsIncludedUrl,
        getAlgoliaModuleDataUrl,
        getPluginViewModelUrl
    };
})();

export default urlHelper;